module.exports = __webpack_public_path__ + "assets/img/10eeca323ff983f527f4d0b3218b7266.png";